<script>
import markdownIt from 'markdown-it';
import markdownItLatex from 'markdown-it-latex';
import miip from 'markdown-it-imsize';
import markdownItTexMath from 'markdown-it-texmath';

import 'markdown-it-latex/dist/index.css';
import 'katex/dist/katex.min.css';
import 'markdown-it-texmath/css/texmath.css';

const mdi = markdownIt({
	html: true,
	linkify: false,
	typographer: true
});

mdi.use(markdownItLatex);
mdi.use(miip, { autofill: true });

mdi.use(markdownItTexMath, {
	engine: require('katex'),
	delimiters: 'brackets',
	katexOptions: { macros: { '\\RR': '\\mathbb{R}' } }
});

export default {
	props: {
		contenido: {
			type: String,
			default: ''
		},
		agregado: {
			type: String,
			default: ''
		}
	},
	computed: {
		render() {
			if (this.agregado)
				return mdi.render(this.agregado + ' ' + this.contenido);
			return mdi.render(this.contenido);
		}
	}
};
</script>
<template>
	<div class="mdItem" v-html="render" />
</template>

<style>
.mdItem img {
	max-width: 100%;
}
</style>
